const ERRORS = {
  ASSEMBLE_PROFILE : 'error assembling profile in InitialDataAssembler',
  FORMAT_HOLIDAYS : 'errors formatting holidays in InitialDataAssembler',
  FORMAT_ALL_PERIODS : 'errors formatting all periods in InitialDataAssembler'
};

export default ERRORS;



// WEBPACK FOOTER //
// ./client/app/common/errors/formatter.errors.js